import { Analytics } from '@segment/analytics-next';
import { ActionMenuItem } from '../../commons/components/GrowegyMenu';
import { CheckboxCheckedIcon } from '../../assets/icons';
import { openUrlInNewTab } from '../../util/window-utils';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';

export const createReleasesMenuItem = (
  isHidden: boolean,
  analytics?: Analytics,
  dataTest?: string
): ActionMenuItem => ({
  type: 'standard',
  text: 'Releases',
  icon: <CheckboxCheckedIcon />,
  isHidden,
  dataTest,
  onClick: () =>
    openUrlInNewTab('https://www.growegy.com/resources/support/releases/', {
      analytics,
      analyticsEvent: AnalyticsEvent.RELEASES_OPENED,
    }),
});
